/**
 * Liquid UI tokens for the admin panel — mirrors the CRM glass design system.
 */
import GlassMixin, {
  BaseGlassMixin,
  GlassMixinVariant2,
} from "../../common/components/GlassMixin"
import BackgroundImage from "../../static/images/smartsetter-glass-effect-light-v4-bg.png"

export const ADMIN_FONT_FAMILY = "Inter, sans-serif"

export const adminPageSx = {
  fontFamily: ADMIN_FONT_FAMILY,
  color: "text.primary",
}

export const adminLayoutBackgroundSx = {
  minHeight: "100vh",
  backgroundImage: `url(${BackgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
}

export const adminLiquidSurfaceSx = {
  position: "relative",
  borderRadius: "16px",
  ...GlassMixin,
  boxShadow: "0 4px 30px rgba(18, 16, 16, 0.1)",
}

export const adminLiquidPanelSx = {
  position: "relative",
  borderRadius: "16px",
  ...GlassMixinVariant2,
}

export const adminLiquidCardSx = {
  position: "relative",
  borderRadius: "16px",
  ...BaseGlassMixin,
  border: "1px solid rgba(255, 255, 255, 0.65)",
}

export const adminLiquidPageContentSx = {
  position: "relative",
  borderRadius: "16px",
  p: { xs: 2, sm: 3 },
  ...GlassMixin,
  boxShadow: "0 4px 30px rgba(18, 16, 16, 0.1)",
}

export const adminLiquidTableShellSx = {
  position: "relative",
  borderRadius: "16px",
  p: 0,
  overflow: "hidden",
  ...GlassMixin,
  boxShadow: "0 8px 24px rgba(17, 12, 46, 0.06)",
}

export const adminLiquidToolbarSx = {
  p: { xs: 1.5, sm: 2 },
}

export const adminLiquidToolbarInnerSx = {
  px: 2,
  py: 1.5,
  borderBottom: "1px solid rgba(255, 255, 255, 0.45)",
  bgcolor: "rgba(249, 248, 252, 0.55)",
  backdropFilter: "blur(12px)",
}

export const adminLiquidTableFooterSx = {
  borderTop: "1px solid rgba(255, 255, 255, 0.45)",
  bgcolor: "rgba(249, 248, 252, 0.72)",
  backdropFilter: "blur(12px)",
  px: { xs: 1.5, sm: 2 },
  pt: { xs: 0.75, sm: 1 },
  pb: { xs: 2, sm: 2.5 },
  "& > div": {
    paddingTop: 0,
    paddingBottom: 0,
  },
}

export const adminLiquidEmptyStateSx = {
  borderRadius: "12px",
  bgcolor: "rgba(255, 255, 255, 0.45)",
  backdropFilter: "blur(12px)",
  border: "1px dashed rgba(147, 32, 213, 0.18)",
}

export const adminLiquidTabsSx = {
  position: "relative",
  borderRadius: "16px",
  px: { xs: 1, sm: 1.5 },
  ...GlassMixinVariant2,
  "& .MuiTabs-indicator": {
    height: 3,
    borderRadius: "3px 3px 0 0",
  },
}

export function getAdminLiquidCardSx() {
  return {
    position: "relative",
    borderRadius: "16px",
    ...BaseGlassMixin,
    border: "1px solid rgba(255, 255, 255, 0.65)",
  }
}

/** @deprecated Use adminLiquidCardSx */
export const adminSurfaceSx = adminLiquidCardSx

/** @deprecated Use getAdminLiquidCardSx */
export function getAdminSurfaceSx(theme) {
  return getAdminLiquidCardSx()
}
